import React from 'react';
import cn from "classnames";

import s from './label.module.scss'

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {

};

export const Label: React.FC<LabelProps> = (props) => {
    return (
        <label
            {...props}
            className={cn(
                s['label'],
                props.className || '',
            )}
        >
            {props.children}
        </label>
    );
};
